// extracted by mini-css-extract-plugin
module.exports = {"formItemOCR":"ocrTooltip_formItemOCR__26vKg","optional":"ocrTooltip_optional__rVEb8","tooltip":"ocrTooltip_tooltip__3Fd6n"};